export const COLORS = [
  'var(--color-underwater-fern-green)',
  'var(--color-deep-river)',
  'var(--color-nirvana-jewel)',
  'var(--color-fusion-red)',
  'var(--color-bhanzu-orange)',
  'var(--color-hot-sun)',
  'var(--color-patrice-green)',
  'var(--color-shovel-knight)',
  'var(--color-cold-lips)',
  'var(--color-purplish-blue)',
];

// Hex palette for unit tests expecting hex values
export const TEST_HEX_COLORS = ['#07A374', '#0079B5', '#4B8488', '#CC4B4B'];
